import { StyledWizardAnimationItem } from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/styles";
import { AssetsService } from "app/services/AssetsService";
import type { ReactElement } from "react";
import { StyledWizardLoadingWrapper } from "./styles";

interface Props {
    isLoading?: boolean;
    children: ReactElement
}

const WizardLoading = ({ isLoading, children }: Props): ReactElement => {
    if (isLoading) {
        return (
            <StyledWizardLoadingWrapper>
                <StyledWizardAnimationItem delay={500}>
                    <div className="sw_loader loading">
                        <img
                            src={AssetsService.assetUrl("/images/section-loader.gif")}
                            alt="Loading..."
                        />
                    </div>
                </StyledWizardAnimationItem>
            </StyledWizardLoadingWrapper>
        )
    }

    return children;
}

export default WizardLoading;